module.exports = __webpack_public_path__ + "static/img/bianji.8b02619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bianji.png
// module id = oDom
// module chunks = 1